module.exports = __webpack_public_path__ + "img/kleisma4m-m@1.039bf60e.webp";